const doc = [({"da":({"js":({"users":({"edit":({"school":({"school":"Skole", "choose_school":"Vælg skole"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;